import React from "react";
import { useNavigate } from 'react-router-dom';

export default function JobInactive ({ title }) {
    const navigate = useNavigate();

    const redirectVagas = () => {
        navigate(`/vagas`);
    };

    return (
        <div className="job-inactive">
            <div className="job-inactive-card">
                <div className="job-inactive-emoji">😔</div>
                <h1 className="job-inactive-title">Ops ... {title} não está mais ativa</h1>
                <p className="job-inactive-text">
                    Esta vaga foi preenchida ou removida pelo anunciante. Agradecemos seu
                    interesse, continue navegando para encontrar outras oportunidades.
                </p>
                <div className="job-inactive-actions">
                    <button className="btn btn-primary" onClick={redirectVagas}>
                        Voltar às vagas
                    </button>
                </div>
            </div>
        </div>
    );
};
